import {
  Input,
  Checkbox,
  Form,
  Divider,
  Radio,
  Select,
  InputNumber,
  DatePicker,
  Row,
  Col,
  Slider,
  Switch,
} from "antd";
import ContentPadding from "../ContentConfig/ContentPadding";
import FormCustomIDField from "../ContentConfig/FormCustomIDField";
import moment from "moment";
import { ColorPickerFormItem } from "../Image/ImageConf";

const TIME_END_ANIMATION = [
  { label: "No animation", value: "none" },
  { label: "Bounce", value: "bounce" },
  { label: "Flash", value: "flash" },
  { label: "Pulse", value: "pulse" },
  { label: "Rubber Band", value: "rubberBand" },
  { label: "Shake X", value: "shakeX" },
  { label: "Shake Y", value: "shakeY" },
  { label: "Head Shake", value: "headShake" },
  { label: "Swing", value: "swing" },
  { label: "Tada", value: "tada" },
  { label: "Wobble", value: "wobble" },
  { label: "Jello", value: "jello" },
  { label: "Heart Beat", value: "heartBeat" },
];

const LABEL_FORMAT = [
  {
    label: "days, hours, minutes, seconds",
    value: "days-hours-minutes-seconds",
  },
  { label: "days, hrs, mins, secs", value: "days-hrs-mins-secs" },
  { label: "DD, HH, MM, SS", value: "DD-HH-MM-SS" },
  { label: "D, H, M, S", value: "D-H-M-S" },
];

const CLOCK_FACE = [
  {
    label: "Flip cards",
    value: "flip",
  },
  {
    label: "Simple text",
    value: "text",
  },
];

const CustomDateTimePicker = (props: unknown) => {
  const { value, onChange, component: Component, ...other } = props;
  const time = value ? moment(value) : null;

  const triggerChange = (_: unknown, dateStr: string) => {
    const timestamp = moment(dateStr).valueOf();
    onChange && onChange(timestamp);
  };

  return <DatePicker defaultValue={time} onChange={triggerChange} {...other} />;
};

export default ({ node }) => {
  return (
    <>
      <Form.Item label="Date type" name="dateType">
        <Radio.Group buttonStyle="solid">
          <Radio.Button value="fixed">Fixed</Radio.Button>
          <Radio.Button value="variable">Variable</Radio.Button>
        </Radio.Group>
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const dateType = getFieldValue("dateType");
          if (dateType === "fixed") {
            return (
              <Form.Item label="Fixed date" name="fixedDate">
                <CustomDateTimePicker
                  style={{ width: "100%" }}
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </Form.Item>
            );
          }
          return (
            <>
              <Form.Item label="Variable date">
                <Input.Group compact>
                  <Form.Item noStyle name="days">
                    <InputNumber
                      placeholder="Days"
                      style={{ width: "33.333%" }}
                      max={99}
                      min={0}
                    />
                  </Form.Item>
                  <Form.Item noStyle name="hours">
                    <InputNumber
                      placeholder="Hours"
                      style={{ width: "33.333%" }}
                      max={23}
                      min={0}
                    />
                  </Form.Item>
                  <Form.Item noStyle name="minutes">
                    <InputNumber
                      placeholder="Minutes"
                      style={{ width: "33.333%" }}
                      max={59}
                      min={0}
                    />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </>
          );
        }}
      </Form.Item>

      <Form.Item label="When timer ends" name="timeEndAnimation">
        <Select options={TIME_END_ANIMATION} />
      </Form.Item>
      <Form.Item name="hideLabel" valuePropName="checked">
        <Checkbox>Hide Label</Checkbox>
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const hideLabel = getFieldValue("hideLabel");
          return (
            <Form.Item label="Label format" name="labelFormat">
              <Select disabled={hideLabel} options={LABEL_FORMAT} />
            </Form.Item>
          );
        }}
      </Form.Item>

      <FormCustomIDField />
      <strong>Style</strong>
      <Divider style={{ margin: "12px 0" }} />
      <Form.Item label="Clock face" name="clockFace">
        <Select options={CLOCK_FACE} />
      </Form.Item>

      <div style={{ display: "flex", gap: 16, marginTop: 10, marginBottom: 10 }}>
        <label>Auto size</label>
        <Form.Item noStyle valuePropName="checked" name={"autoSize"}>
          <Switch />
        </Form.Item>
      </div>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const auto = getFieldValue("autoSize");
          if (!auto) { 
            return (
              <Form.Item noStyle name="clockWidth">
                <Slider
                  style={{ width: "90%" }}
                  min={300}
                  max={900}
                  step={10}
                  marks={{ 300: "-", 900: "+" }}
                  tipFormatter={(v) => `${v}px`}
                />
              </Form.Item>
            );
          }
          return null;
        }}
      </Form.Item>

      <Row gutter={8}>
        <Col span={12}>
          <ColorPickerFormItem
            label={"Label Color"}
            name="labelColor"
            color={node.data.labelColor || { r: 204, g: 204, b: 204, a: 1 }}
          />
        </Col>
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) => {
            const clockFace = getFieldValue("clockFace");
            return (
              <Col span={12}>
                <ColorPickerFormItem
                  disabled={clockFace === "text"}
                  label={"Card Color"}
                  name="cardColor"
                  color={node.data.cardColor || { r: 51, g: 51, b: 51, a: 1 }}
                />
              </Col>
            );
          }}
        </Form.Item>
      </Row>
      <ContentPadding />
    </>
  );
};
